import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { deofuscate } from '@/utils/obfuscation';
import { PersonService } from '@/services/person/person.service';
import { Person } from '@/interfaces/person';
import { BoxColors } from '@/shared/person-card/person-card.component';

@Component({
  templateUrl: './result.component.html',
  styleUrls: ['./result.component.css'],
})
export class ResultComponent implements OnInit {

  selectedPersonData?: Person;
  personBoxColor: BoxColors = BoxColors.BROWN_GREY;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    // private auth: AuthService,
    // private store: Store<StoreState>,
    private personService: PersonService,
  ) { }

  ngOnInit(): void {
    this.route.params.pipe().subscribe(({ ofuscatedData }) => {
      const params = deofuscate(ofuscatedData);
      this.personService.getPersonDataById(params.personId).subscribe({
        next: (personData) => {
          this.selectedPersonData = personData;
        },
      });
    });
  }

  searchAnotherPerson() {
    this.router.navigateByUrl('/license/show-deleted');
  }

}
